import React from 'react'
import { SupportStaffProvider } from '../../supportStaff'
import { ListingTemplate } from 'views/components'
import AdminOnboardingPage from './AdminOnboardingPage'

const AdminOnboardingRoute = () => (
  <SupportStaffProvider>
    <ListingTemplate Header={<div style={{ minHeight: '71px' }}></div>} Body={<AdminOnboardingPage />} />
  </SupportStaffProvider>
)

export default AdminOnboardingRoute
